// extracted by mini-css-extract-plugin
export default {"viewer":"PdfViewer_viewer__27y2d","fullHeight":"PdfViewer_fullHeight__TkKCd"};